module.exports = __webpack_public_path__ + "static/Prof.CitaRositaSigitPrakoeswaMDPhD-4b16c2fea25a044d94d43be81b52ae8d.jpg";